import { Routes, Route } from "react-router-dom";

import { HomePage } from "./pages/HomePage";
import { AdminPage } from "./pages/AdminPage";

function App() {
  return (
    <Routes>
      <Route exact path="/" element={<HomePage />} />
      <Route exact path="admin" element={<AdminPage />} />
    </Routes>
  );
}

export default App;
